import { IconButton, ListItemText, useMediaQuery } from "@material-ui/core";
import React, { memo, useEffect, useRef, useState } from "react";
import { meetingService } from "../../../services/meeting/meeting.service";
import { MeetingLayout } from "../../components/MeetingLayout";
import json2mq from "json2mq";
import { templateService } from "../../../services/cms/template/template.service";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import clsx from "clsx";
import ListItem from "@material-ui/core/ListItem";
import MenuIcon from "@material-ui/icons/Menu";

const areEqual = (prevProps, nextProps) => {
  if (nextProps !== prevProps) {
    return false;
  } else if (nextProps.moduleChangeKey != prevProps.moduleChangeKey) return false;
  return true;
};

export const ContentView = memo((props) => {
  const [layouts, setLayouts] = useState([]);
  const [layout, setLayout] = useState(null);
  const [currentTemplate, setCurrentTemplate] = useState(null);

  const layoutRef = useRef(null);

  layoutRef.current = layout;

  const { eventId, moduleChangeKey, hubConnection, settings, preview } = props;

  const { menuOptions } = settings;

  useEffect(() => {
    fetchLayouts();
    if (hubConnection) hubConnection.on("onGetActiveMeetingLayout", onGetActiveMeetingLayout);
    return () => {
      if (hubConnection) hubConnection.off("onGetActiveMeetingLayout", onGetActiveMeetingLayout);
    };
  }, []);

  useEffect(() => {
    if (!layout) fetchLayouts();
  }, [props.layout]);

  useEffect(() => {
    if (hubConnection) hubConnection.on("onGetActiveMeetingLayout", onGetActiveMeetingLayout);
    return () => {
      if (hubConnection) hubConnection.off("onGetActiveMeetingLayout", onGetActiveMeetingLayout);
    };
  }, [layout]);

  const onGetActiveMeetingLayout = () => {
    if (!layoutRef.current) return null;
    meetingService.getLayouts(eventId).then((res) => {
      setLayout(res.find((d) => d.meetingLayoutId == layoutRef.current.meetingLayoutId));
      setLayouts(res);
    });
  };

  const fetchLayouts = () => {
    meetingService.getLayouts(eventId).then((res) => {
      setLayout(settings.menuOptions[0] && settings.menuOptions[0].layoutId ? res.find((r) => r.meetingLayoutId == settings.menuOptions[0].layoutId) : null);
      setLayouts(res);
    });
  };

  const moduleIsInLayout = (module) => {
    const { meetingModuleId } = module;
    return layout.meetingModules.find((mm) => mm.meetingModule.meetingModuleId == meetingModuleId);
  };

  const onNavigate = (id, item) => {
    const l = layouts.find((l) => l.meetingLayoutId == id);
    if (!l && !item.url) return;
    else if (item.url && !l) window.open(item.url, "_blank");
    setLayout(l);
    templateService.get(l.templateId).then((res) => {
      setCurrentTemplate(res);
    });
  };

  const moduleBlueprint = (meetingModuleId) => {
    const layoutModule = layout.meetingModules.find((mm) => mm.meetingModule.meetingModuleId == meetingModuleId);
    if (!layoutModule) return {};
    const { posX, posY, height, width, zIndex } = layoutModule;
    const requirements = { posX, posY, height, width, zIndex };
    return requirements;
  };

  const isSmartphone = useMediaQuery(
    json2mq({
      maxWidth: 600,
    })
  );
  if (!layout && !preview) return null;
  const DASettings = {
    noneAllowedSpeakers: props.noneAllowedSpeakers,
    checkBreakoutVistorMax: props.checkBreakoutVistorMax,
    allowChatVideoCall: props.allowChatVideoCall,
    allowFullscreen: props.allowFullscreen,
    allowSpeaker: props.allowSpeaker,
    clientName: props.clientName,
    personTypes: props.personTypes,
    chatAdmin: props.chatAdmin,
    chatAlias: props.chatAlias,
    clientInitial: props.clientInitial,
    collapsibleAgenda: props.collapsibleAgenda,
    parentEventCode: props.parentEventCode,
    companyName: props.companyName,
    allowModeratorChat: props.allowModeratorChat,
    interactionAllowOneToOneChat: props.interactionAllowOneToOneChat,
    enableZoomScreenShare: props.enableZoomScreenShare,
    dismissConnectionLoss: props.dismissConnectionLoss,
    linkedIn: props.linkedIn,
    title: props.title,
    disableGroupChat: props.disableGroupChat,
    anonymous: props.anonymous,
    profileImage: props.profileImage,
    tickCode: props.tickCode,
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div style={{ width: "100%", height: 50, background: "red", color: "#fff", borderStyle: "solid", display: "flex", justifyContent: "center", alignItems: "center", ...settings }}>
        {isSmartphone || (preview && layout?.mobile) ? (
          <MobileMenu preview={preview} settings={settings} menuItems={menuOptions} onNavigate={onNavigate} layout={layout} />
        ) : (
          <>
            {menuOptions.map((mo) => {
              return (
                <span key={mo.layoutId} style={{ margin: "0px 10px", cursor: "pointer" }} onClick={() => onNavigate(mo.layoutId, mo)}>
                  {mo.label}
                </span>
              );
            })}
          </>
        )}
      </div>
      {!preview ? (
        <MeetingLayout
          {...DASettings}
          moduleChangeKey={moduleChangeKey}
          template={currentTemplate || props.template}
          mobileLayout={layout.mobile}
          fonts={props.fonts}
          hasParent={true}
          modules={props.modules}
          moduleIsInLayout={moduleIsInLayout}
          moduleBlueprint={moduleBlueprint}
          noFontLoad={true}
          connected={props.connected}
          lang={props.lang}
          hubConnection={props.hubConnection}
          orderList={props.orderList}
          clientKey={props.clientKey}
        />
      ) : null}
    </div>
  );
}, areEqual);

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

const MobileMenu = ({ menuItems, onNavigate, layout, settings, preview }) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {menuItems.map((item, index) => (
          <ListItem button key={item.id} onClick={() => onNavigate(item.layoutId, item)}>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
      <Divider />
    </div>
  );

  return (
    <>
      {["left"].map((anchor) => (
        <div key={anchor} style={{ position: "relative", display: "flex", width: "100%", justifyContent: "flex-start" }}>
          <IconButton disabled={preview} onClick={toggleDrawer(anchor, true)}>
            <MenuIcon style={{ color: settings.color }} />
          </IconButton>
          <span style={{ flexBasis: "100%", display: "flex", paddingRight: 48, alignItems: "center", justifyContent: "center" }}>{layout?.name}</span>
          <SwipeableDrawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)} onOpen={toggleDrawer(anchor, true)}>
            {list(anchor)}
          </SwipeableDrawer>
        </div>
      ))}
    </>
  );
};
